
/**
 * MV库 Model
 */
import cloneDeep from 'lodash-es/cloneDeep'
const undef = undefined

// 付费信息
const mvPayment = {
  preSaleBegin: null,
  paymentBegin: null,
  paymentEnd: null,
  price: 0,
  paymentModeId: ''
}

const extend = {
  director: '',
  editor: '',
  actor: '',
  producer: '',
  srcSingerName: '',
  tvName: '',
  subTitle: '',
  displayTime: '',
  displayCompanyName: '',
  parentGuidance: '0'
}

const mediaInfo = {
  codecType: '',
  videoBitrate: 0,
  audioBitrate: 0,
  frameRate: 0,
  imageHeight: 0,
  imageWidth: 0,
  channels: 0,
  audioSampleRate: 0,
  duration: 0
}

const complaint = {
  ccReason: undef,
  ccFrom: '',
  ccPlatform: '',
  cpRemarks: '',
  ccCompany: undef,
  originCpCompanyId: 0,
  cpCompanyId: 0,
  ccTime: undef,
  copyrightFrom: undef,
  copyrightTo: undef,
}

const defaultCopyright = {
  cpCompany: '',
  originCpCompany: {
    companyName: ''
  },
  copyright: '',
  date: [],
  isAgent: 0,
  isOnly: 0,
  canAuth: 0,
  // authProduct: [],
  copyrightArea: [],
  cpSource: 1,
  isOverseaOnly: 0,
}

export default class Mv {
  constructor(initObj = {}) {
    const mvSingerList = []
    let mvPhotoList = []
    const mvExtend = {
      ...extend,
      ...initObj.mvExtend
    }
    const mvMediaInfo = {
      ...mediaInfo,
      ...(initObj.mvMediaInfo || {})
    }
    const tp = {
      ...mvPayment,
      ...initObj.mvPayment,
    }
    const mvComplaint = {
      ...complaint,
      ...initObj.mvComplaint,
    }

    let mvLicenseList = []

    mvComplaint.ccCompany = (mvComplaint.ccCompany && mvComplaint.ccCompany.companyId) ? `${mvComplaint.ccCompany.companyId} -@- ${mvComplaint.ccCompany.companyName}` : ''
    mvComplaint.ccReason = mvComplaint.ccReason === 0 ? '' : mvComplaint.ccReason

    // 艺人
    if (initObj.mvSingerList) {
      initObj.mvSingerList.forEach(singer => {
        // 如果是库外艺人, 不显示 id
        const value = singer.isOfficial ? `${singer.singerName}` : singer.singerName
        mvSingerList.push({
          ...singer,
          id: singer.id,
          value,
          label: value,
        })
      })
    }

    // 基础信息
    this.tempId = initObj.mvId || `tempId_${Date.now()}`
    this.mvId = initObj.mvId
    this.srcMvId = initObj.srcMvId || ''
    // this.mvVid = initObj.mvVid || ''
    this.mvName = initObj.mvName || ''
    this.srcMvName = initObj.srcMvName || ''
    this.transName = initObj.transName || ''
    this.otherName = initObj.otherName || ''
    this.mvSingerList = mvSingerList
    this.version = initObj.version || 0
    this.srcVersion = initObj.srcVersion || ''
    this.area = initObj.area || 0
    this.language = initObj.language ? initObj.language : 0
    this.genre = initObj.genre || ''
    this.srcGenre = initObj.srcGenre ? initObj.srcGenre.split('|') : []
    this.publicTime = initObj.publicTime
    this.saleTime = initObj.saleTime
    this.attr = initObj.attr || 0
    this.status = initObj.status || 0
    this.hideReason = initObj.hasOwnProperty('hideReason') ? initObj.hideReason : 12
    this.fFrom = initObj.fFrom != null ? initObj.fFrom : 0
    this.desc = initObj.desc || ''
    this.replaceMvId = initObj.replaceMvId || 0
    this.trackIdList = initObj.trackIdList || ''
    this.firstPublicTime = initObj.firstPublicTime || null
    this.upc = initObj.upc || ''
    this.isrc = initObj.isrc || ''
    this.mvNumber = initObj.mvNumber || ''
    this.displayCompanyName = initObj.displayCompanyName || ''

    if (initObj.mvLicenseList) {
      mvLicenseList = initObj.mvLicenseList.map(license => {
        return {
          ...license,
          name: license.fileName,
          url: license.licenseUrl,
        }
      })
    }

    // 图片
    if (initObj.mvPhotoList) {
      mvPhotoList = initObj.mvPhotoList.map(photo => {
        return {
          ...photo,
          url: photo.photoUrl,
        }
      })
    }

    this.mvLicenseList = mvLicenseList
    this.mvMedia = initObj.mvMedia || []
    this.mvPhotoList = mvPhotoList
    this.srcMvPhotoList = initObj.srcMvPhotoList || []

    // 拓展信息
    this.mvExtend = mvExtend

    // 视频信息
    this.mvMediaInfo = mvMediaInfo

    // 版权信息
    this.mvCopyright = initObj.mvCopyright || cloneDeep(defaultCopyright)

    // 投诉信息
    this.mvComplaint = mvComplaint

    // 付费信息
    this.mvPayment = tp
  }
}
